// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Lato', 'Lato Fallback'","fontWeight":400},"className":"__className_222a05","variable":"__variable_222a05"};